import React from 'react';

export default function ForgotPasswordForm({
  forgotEmail, onForgotEmailChange, onForgotSubmit,
  resetForm, onResetFormChange, onResetSubmit,
}) {
  return (
    <>
      <form onSubmit={onForgotSubmit} className="auth-form">
        <div className="form-field">
          <label>Correo registrado</label>
          <input
            type="email"
            value={forgotEmail}
            onChange={e => onForgotEmailChange(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-primary full">Solicitar recuperación</button>
      </form>

      <div className="info-box">Revisa tu correo para obtener el token de recuperacion.</div>

      <hr className="divider" />

      <form onSubmit={onResetSubmit} className="auth-form">
        <div className="form-field">
          <label>Token de recuperación</label>
          <input
            value={resetForm.token}
            onChange={e => onResetFormChange({ ...resetForm, token: e.target.value })}
            required
          />
        </div>
        <div className="form-field">
          <label>Nueva contraseña</label>
          <input
            type="password"
            value={resetForm.newPassword}
            onChange={e => onResetFormChange({ ...resetForm, newPassword: e.target.value })}
            required
          />
        </div>
        <button type="submit" className="btn-primary full">Cambiar contraseña</button>
      </form>
    </>
  );
}
